export const CopiedIcon = ({
	color = 'var(--mono100)',
	width = '24',
	height = '24',
	...props
}): JSX.Element => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path
			d="M13.5273 21H6.8125C5.26164 21 4 19.7384 4 18.1875V8.66016C4 7.1093 5.26164 5.84766 6.8125 5.84766H13.5273C15.0782 5.84766 16.3398 7.1093 16.3398 8.66016V18.1875C16.3398 19.7384 15.0782 21 13.5273 21ZM6.8125 7.25391C6.03714 7.25391 5.40625 7.8848 5.40625 8.66016V18.1875C5.40625 18.9629 6.03714 19.5938 6.8125 19.5938H13.5273C14.3027 19.5938 14.9336 18.9629 14.9336 18.1875V8.66016C14.9336 7.8848 14.3027 7.25391 13.5273 7.25391H6.8125ZM19.1523 16.4297V5.8125C19.1523 4.26164 17.8907 3 16.3398 3H8.53516C8.14679 3 7.83203 3.31476 7.83203 3.70312C7.83203 4.09149 8.14679 4.40625 8.53516 4.40625H16.3398C17.1152 4.40625 17.7461 5.03714 17.7461 5.8125V16.4297C17.7461 16.8181 18.0609 17.1328 18.4492 17.1328C18.8376 17.1328 19.1523 16.8181 19.1523 16.4297Z"
			fill={color}
		/>
	</svg>
)
